<template>
  <Slide right>
    <router-link to="/our-story/" class="orange-link">
      >
      <span class="orange-link">Our Story</span>
    </router-link>
    <router-link to="/mortgage-advice/" class="orange-link">
      >
      <span class="orange-link">Mortgage Advice</span>
    </router-link>
    <a href="https://www.rightmove.co.uk/estate-agents/agent/Friday-and-Co-Estate-Agents/Lowestoft-291410.html" target="_blank" rel="nofollow" class="orange-link">
     >
     <span class="orange-link">Our Properties</span>
    </a>
    <router-link to="/contact-us/" class="orange-link">
      >
      <span class="orange-link">Contact Us</span>
    </router-link>
    <a href="tel:01502802347" class="orange-link">
      <span>
        <strong>01502 802347</strong>
      </span>
    </a>
    <div class="vf-prof-review">
      <div class="vf-prof-34439">
        <a href=https://www.vouchedfor.co.uk/mortgage-advisor/lowestoft/034439-andrew-friday/reviews title="Reviews and Ratings for Financial adviser Andrew Friday, Norwich"><img src=https://assets.vouchedfor.co.uk/widgets/ratings-and-reviews/legacy-version/img/ajax-loader.gif style="padding-top:20px" alt="Reviews and Ratings for Financial adviser Andrew Friday, Norwich" /></a>
      </div>
    </div>
  </Slide>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "mobile-menu",
  components: {
    Slide,
    },
    mounted() {
      if (document.querySelector(".vf-prof-review")) {
        const scriptOne = document.createElement("script");
        const containerOne = document.querySelector(".vf-prof-review");
        scriptOne.type = "text/javascript";
        scriptOne.src = "https://api.vouchedfor.co.uk/v0/public/widget/customer-rating";
        containerOne.prepend(scriptOne);

        const scriptTwo = document.createElement("script");
        const containerTwo = document.querySelector(".vf-prof-34439");
        scriptTwo.type = "text/javascript";
        scriptTwo.innerHTML = "setTimeout(function () { contentLoaded(window, function (e) { vf_get_ratings('MzQ0Mzk=', 'vf-prof-34439') });}, 1500);";
        containerTwo.appendChild(scriptTwo);
      }
    }
};
</script>

<style scoped>
.orange-link {
  text-decoration: none !important;

}
.orange-link:hover{
  color: #f7941d;
}
.btn-item-list>* {
  text-decoration: none !important;
}
.bm-item-list>*>span:hover {
  color: #f7941d !important;

}
</style>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue